import React from 'react'
import { SectionCListLayer } from '../components/ImportQuestion/SectionCListLayer'
import MasterLayout from '../masterLayout/MasterLayout'

export const SectionCListPage = () => {
  return (
    <MasterLayout>

        <SectionCListLayer />
    </MasterLayout>
  )
}
